import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { styled } from '@mui/styles'
import { Utils } from '@pbt/pbt-ui-components'

import Typography from '~/components/elements/Typography/Typography'
import { getAnswerInputTypes } from '~/store/reducers/constants'
import type { QuestionTimelineItemEntry } from '~/types'

import { getText } from './cardUtils'

const StyledTypography = styled(Typography.Paragraph)(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
  whiteSpace: 'pre-wrap',
}))

const AnswerItem = ({
  entry,
  children,
  answerText: answerTextProp,
}: {
  answerText?: string | null
  children?: ReactNode
  entry: QuestionTimelineItemEntry
}) => {
  const { t } = useTranslation(['Common', 'Clients'])
  const AnswerInputTypes = useSelector(getAnswerInputTypes)

  const DateSelector = Utils.findConstantIdByName(
    'Date selector',
    AnswerInputTypes,
  )

  const answerText =
    answerTextProp !== undefined ? answerTextProp : entry.answerText
  const { answerInputTexts } = entry

  const text = getText(answerText, answerInputTexts, t, DateSelector)
  const hasText = Boolean(text && text.trim() !== '')

  return (
    <>
      <li>
        {hasText && <StyledTypography>{text}</StyledTypography>}
        {children}
      </li>
    </>
  )
}

export default AnswerItem
